/**
 * <ry-heading>
 *
 * Section heading with optional subtitle.
 *
 * Usage:
 * <ry-heading>Page Title</ry-heading>
 * <ry-heading sub="A brief description" align="center">Centered Title</ry-heading>
 */

import { RyElement } from '../core/ry-element.js';

export class RyHeading extends RyElement {
  setup(): void {
    this.#transformMarkup();
  }

  #transformMarkup(): void {
    if (this.$('[data-ry-target="title"]')) return;

    const subText = this.getAttribute('sub') ?? '';
    const titleText = this.innerHTML.trim();

    this.innerHTML = `
      <div data-ry-target="title" class="ry-heading__title">${titleText}</div>
      ${subText ? `<div data-ry-target="sub" class="ry-heading__sub">${subText}</div>` : ''}
    `;
  }
}

customElements.define('ry-heading', RyHeading);
